import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  background-color: #001199;
  color: #fff;
  padding: 2rem;
`;

export const FooterContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;

  @media (min-width: 640px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledLink = styled.a`
  cursor: pointer;
  background: transparent;
  width: fit-content;
  height: fit-content;
  border: none;
`;

export const InfoContainer = styled.div`
  h3 {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: 28px;
    letter-spacing: -1px;
  }

  p {
    margin-top: 16px;
    letter-spacing: -1px;
    font-weight: 500;

    a {
      text-decoration-line: underline;
      color: #fff;
    }

    &.mt-negative {
      margin-top: -4px;
    }
  }
`;

export const BottomLinks = styled.ul`
  margin-top: 16px;
  display: flex;
  flex-direction: column;

  @media (min-width: 640px) {
    flex-direction: row;
    gap: 1.5rem;
  }

  li {
    font-size: 0.875rem;

    a {
      color: #fff;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
